import { Alert, type AlertColor } from "@mui/material";
import {
  closeSnackbar,
  SnackbarContent,
  type CustomContentProps,
  type VariantType,
} from "notistack";
import React from "react";

const severityByVariant: Record<VariantType, AlertColor> = {
  default: "info",
  error: "error",
  info: "info",
  success: "success",
  warning: "warning",
};

/** Notistack content styled to match the app's MUI Snackbar + Alert treatment. */
export const MuiAlertSnackbar = React.forwardRef<HTMLDivElement, CustomContentProps>(
  ({ id, message, variant }, ref) => (
    <SnackbarContent ref={ref} style={{ width: "100%" }}>
      <Alert
        severity={severityByVariant[variant]}
        onClose={() => closeSnackbar(id)}
        sx={{ width: "100%", alignItems: "center" }}
      >
        {message}
      </Alert>
    </SnackbarContent>
  ),
);

MuiAlertSnackbar.displayName = "MuiAlertSnackbar";
